
import { NgModule } from '@angular/core';

import { StructureTotemEditProvider } from './structure_totem-edit.provider';
import { StructureTotemListProvider } from './structure_totem-list.provider';

export * from './structure_totem-edit.provider';
export * from './structure_totem-list.provider';

export {
  StructureTotemListProvider as TotemTOListProvider,
  StructureTotemEditProvider as TotemTOEditProvider
};

@NgModule({
  declarations: [

  ],
  imports: [
  ],
  exports: [

  ],
  providers: [
    StructureTotemEditProvider,
    StructureTotemListProvider
  ]
})
export class TotemTOBackendModule { }
